export const environment = {
  appId: 'com.sonespacesante.sonespacesante',
  appStoreId: '6744027012',
  production: true,
  APP_VERSION: 'SonEspaceSante',
  APP_NAME: 'Son espace santé',
  APP_NAME_FORMATTED: '<span class="highlight">Son</span> espace santé',
  API_URL: 'https://server.sonespacesante.fr/fr/',
  API_URL_CLEAR: 'https://server.sonespacesante.fr/',
  STATIC_URL: 'https://static.sonespacesante.fr/',
  MEDIA_URL: 'https://media.sonespacesante.fr/',
  URL: 'https://apps.sonespacesante.fr',
  googleClientIdWEB: '545486694753-nbu4nrkjh6v506uitn9i04mlor2dgpnt.apps.googleusercontent.com',
  googleClientIdIOS: '545486694753-lcjqv19gbfb16qg7nh53cegnal3o39u3.apps.googleusercontent.com',
  googleClientIdAndroid: '545486694753-jt60g02hr3ijacbjesh28nsco4l7dkkl.apps.googleusercontent.com',
  facebookAppId: '3066901113487491',
  facebookClientTOKEN: '03a41415dd7c39734763f009b888b3b1',
  appleAppId: 'com.sonespacesante.sonespacesante',
  firebase: {
    apiKey: "AIzaSyADgVnqKGpKTiDgWreBEYcLv1nAWRflCU8",
    authDomain: "sonespacesante.firebaseapp.com",
    projectId: "sonespacesante",
    storageBucket: "sonespacesante.firebasestorage.app",
    messagingSenderId: "59156103078",
    appId: "1:59156103078:web:26c9ca54bc0444917c1967",
    vapidKey: "BCpJu7haUKld9kj6NkfjM77RaQFZvqokcn_CyZc5VEykBpmMFUnkQa6aS5wIUdXXtXMjWicF4EtC9sZqkse7GVM"
  },
};
